import type { AluminiumComposition, SpecificationListItem } from 'api';
import { useTranslation } from 'i18n';
import { Stack } from 'ui';

import { buildAluminiumCompositionItems } from '../../utils/buildAluminiumCompositionItems/buildAluminiumCompositionItems';
import { formatDirtScore } from '../../utils/formatDirtScore/formatDirtScore';
import { MaterialBreakdownItem } from '../MaterialBreakdownItem/MaterialBreakdownItem';

export const AluminiumCompositionBreakdown = ({
  composition,
  showAerosol,
  instructions,
}: {
  composition: AluminiumComposition;
  showAerosol?: boolean;
  instructions?: SpecificationListItem[];
}) => {
  const { t } = useTranslation('features');
  const { targetAluminiumSection, nonTargetSection } = buildAluminiumCompositionItems(composition, instructions, {
    showAerosol,
  });

  return (
    <Stack
      data-testid="aluminium-composition-breakdown"
      sx={{
        gap: 2,
      }}
    >
      <div>
        {targetAluminiumSection.items.map((item, index) => (
          <MaterialBreakdownItem
            key={`${item.label}-${index}`}
            label={item.label}
            value={item.value}
            highlight={item.highlight}
            variant={item.variant}
            dataTestId={item.dataTestId}
          />
        ))}
      </div>
      <div>
        {nonTargetSection.items.map((item, index) => (
          <MaterialBreakdownItem
            key={`${item.label}-${index}`}
            label={item.label}
            value={item.value}
            highlight={item.highlight}
            variant={item.variant}
            dataTestId={item.dataTestId}
          />
        ))}
      </div>
      <div>
        <MaterialBreakdownItem
          variant="bold"
          label={t('breakdowns.cleanliness.label')}
          tooltipContent={t('breakdowns.cleanliness.tooltip')}
          value={formatDirtScore(composition.dirt_score)}
        />
      </div>
    </Stack>
  );
};
